import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import { Location } from '@gatsbyjs/reach-router';
import { I18nextProvider } from 'react-i18next';

import reportWebVitals from './reportWebVitals';
import { UserStore } from '@common/stores';
import App from './App';
import store from '@store/store';
import i18n from '@components/i18n/i18n';
import i18nContext from '@components/i18n/i18nContext';

// eslint-disable-next-line
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <UserStore>
        <Location>
          <I18nextProvider i18n={i18n}>
            <i18nContext.Provider
              value={{
                lng: 'en',
                direction: 'ltr',
              }}
            >
              <App location={location} />
            </i18nContext.Provider>
          </I18nextProvider>
        </Location>
      </UserStore>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
